import { injectable } from 'inversify';
import 'reflect-metadata';
import axiosClient from './axios-client';
import { ApiResponse } from '../utils/api-response.utils';
import {
  Setup2FAResult,
  VerifySetupRes,
} from '../_api/new-services/user-two-factor/UserTwoFactorService';

export interface TwoFactorStatusResponse {
  is2FAActive: boolean;
}

@injectable()
export class UserTwoFactorService {
  async skipTwoFactor(): Promise<ApiResponse<boolean | null>> {
    const response = await axiosClient.post<ApiResponse<boolean | null>>(
      '/api/user/skip-2fa-setup'
    );

    return response.data;
  }

  async setupTwoFactor(): Promise<ApiResponse<Setup2FAResult | null>> {
    const response = await axiosClient.post<ApiResponse<Setup2FAResult | null>>(
      '/api/user/setup-2fa'
    );

    return response.data;
  }

  async verifyTwoFactorSetup(
    code: string,
    secret: string
  ): Promise<ApiResponse<VerifySetupRes | null>> {
    const response = await axiosClient.post<ApiResponse<VerifySetupRes | null>>(
      '/api/user/confirm-setup',
      { code, secret }
    );

    return response.data;
  }

  async verifyTwoFactor({
    code,
    backupCode,
  }: {
    code?: string;
    backupCode?: string;
  }): Promise<ApiResponse<boolean | null>> {
    const response = await axiosClient.post<ApiResponse<boolean | null>>(
      '/api/user/verify-2fa',
      { code, backupCode }
    );

    return response.data;
  }

  async resetTwoFactor(password: string): Promise<ApiResponse<boolean | null>> {
    const response = await axiosClient.post<ApiResponse<boolean | null>>(
      '/api/user/reset-2fa',
      { password }
    );

    return response.data;
  }

  async is2FAActive(): Promise<ApiResponse<boolean>> {
    const response = await axiosClient.get<ApiResponse<boolean>>(
      '/api/user/is-2fa-active'
    );
    return response.data;
  }
}
